import getBrowserInfo from 'features/adyen/helpers/getBrowserInfo'
import checkoutSelectors from 'features/checkout/duck/selectors'
import { RootState } from 'redux/types'

import { AdyenPostProceedBody } from './types'

interface PrepareAdyenArgs {
  state: RootState
}

export function prepareAdyen({ state }: PrepareAdyenArgs): AdyenPostProceedBody {
  const { encryptedAdyenForm, adyenRecurringDetailReference, ...restValues } =
    checkoutSelectors.getAdyenCreditCardValues(state)
  const selectedPaymentCardId = checkoutSelectors.getSelectedPaymentCardId(state)
  const adyenInstallment = checkoutSelectors.getAdyenSelectedInstallment(state)
  const body: AdyenPostProceedBody = {
    adyenData: {
      encryptedAdyenForm,
      adyenRecurringDetailReference,
      cardPaymentId: selectedPaymentCardId,
    },
    browserInfo: getBrowserInfo(),
    ...restValues,
  }
  if (adyenInstallment) {
    body.adyenData.adyenInstallment = adyenInstallment
  }

  return body
}
